import { TAB_LABELS } from './constants';

// Tab strip rendered in the header center cell.
// Selected tab: ink fill, paper text, paper-3 num. Unselected: paper bg, ink text, ink-4 num.
// Tabs are separated by hairline rules.

function TabButton({ tab, selected, onClick, style }) {
  return (
    <button
      type="button"
      aria-selected={selected}
      onClick={onClick}
      style={style}
      className={[
        'flex items-center gap-2 px-[22px] h-full',
        'border-r border-hairline last:border-r-0',
        'transition-colors duration-100',
        selected
          ? 'bg-ink text-paper'
          : 'bg-paper text-ink hover:bg-paper-2',
      ].join(' ')}
    >
      <span
        className={[
          'font-mono text-tab-num',
          selected ? 'text-paper-3' : 'text-ink-4',
        ].join(' ')}
      >
        {tab.num}
      </span>
      <span className="text-[13px]">{tab.label}</span>
    </button>
  );
}

export function Tabs({ tab, onTab }) {
  return (
    <div className="flex h-full border-r border-rule">
      {TAB_LABELS.map((t) => (
        <TabButton
          key={t.id}
          tab={t}
          selected={tab === t.id}
          onClick={() => onTab(t.id)}
          style={undefined}
        />
      ))}
    </div>
  );
}

export default Tabs;
